export const PROJECT_CREATED_SUCCESS_TOAST_DISMISS_TEST_ID = 'project-created-success-toast-dismiss'
